const monthlyIncomeOptions = [
  { value: 'no_income', name: 'Não possuo fonte de renda' },
  { value: 'even_a_minimum_wage', name: 'Até R$ 1.100' },
  { value: 'between_one_to_two_minimum_wage', name: 'R$ 1.101 até R$ 2.200' },
  { value: 'between_two_to_three_minimum_wage', name: 'R$ 2.201 até R$ 3.300' },
  {
    value: 'between_three_to_five_minimum_wage',
    name: 'R$ 3.301 até R$ 4.400',
  },
  { value: 'between_five_to_ten_minimum_wage', name: 'R$ 5.501 até R$ 11.000' },
  {
    value: 'between_ten_to_twenty_minimum_wage',
    name: 'R$ 11.001 até R$ 22.000',
  },
  { value: 'more_than_twenty_minimum_wage', name: 'Acima de R$ 22.000' },
  { value: 'unavailable', name: 'Não quero informar minha renda ' },
];

export default monthlyIncomeOptions;
